import { useState } from "react";
import classNames from "classnames";
import { useAsyncDebounce, FilterValue } from "react-table";
import { Button } from "react-bootstrap";

type GlobalFilterProps = {
    preGlobalFilteredRows: any;
    globalFilter: any;
    setGlobalFilter: (filterValue: FilterValue) => void;
    searchBoxClass?: string;
    onSearchClick?: (keyword? : string) => void;
    placeholder?: string;
    searchColumns?: string[];
};

const GlobalFilter = ({ preGlobalFilteredRows, globalFilter, setGlobalFilter, searchBoxClass, onSearchClick, placeholder, searchColumns }: GlobalFilterProps) => {
    const count = preGlobalFilteredRows.length;
    const [value, setValue] = useState<any>(globalFilter);
    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
    }, 200);

    const handleKeyPress = (event: any) => {
        if (event.key === "Enter") {
            onChange(value);
            setValue(value);
            event.preventDefault(); 
            onSearchClick && onSearchClick(value);
        }
    };

    const handleSearchClick = (value:any) => {
        onChange(value);
        onSearchClick && onSearchClick(value);
    };

    return (
        <div className="search d-inline-flex">
            <div className={classNames(searchBoxClass, "search-container")}>
                <span className="d-flex align-items-center">
                    <input
                        value={value || ""}
                        onChange={(e) => setValue(e.target.value)}
                        onKeyDown={handleKeyPress}
                        placeholder={placeholder ?? `Search ${count} records${searchColumns != null && searchColumns.length > 0 ? ` by ${searchColumns.join(" / ")}...` : "..."}`}
                        className="form-control w-100"
                        style={
                            { 
                                minHeight: "38px",
                                borderRadius: "4px 0px 0px 4px"
                            }
                        }
                    />
                </span>
            </div>
            <Button variant="primary" style={{
                borderRadius: "0px 4px 4px 0px"
            }} className="btn-icon me-1 custom-btn-icon filter-btn" onClick={() =>  handleSearchClick(value)}>Search</Button>
        </div>
    );
};

export default GlobalFilter;